import styled from 'styled-components';

export const Header2 = styled.h2`
  font-family: 'Open Sans';
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 2rem;
  color: inherit;
  margin: 0;
  position: relative;
`;
